"use client";

// TODO [TENANT-008]: Create SK-specific theme
import "@kalkulacka-one/design-system/themes/www.volebnikalkulacka.cz/default.css";

export const DefaultTheme = ({ children }: { children: React.ReactNode }) => {
  return children;
};
